import { defineComponent as m, useSlots as f, openBlock as a, createElementBlock as v, normalizeClass as b, unref as r, createBlock as l, createCommentVNode as s, renderSlot as y } from "vue";
import B from "../spinner/IstSpinner.vue.mjs";
import w from "../icon/IstIcon.vue.mjs";
import k from "../../composables/useIsSlotEmpty/useIsSlotEmpty.mjs";
const g = ["disabled", "variant", "aria-label", "aria-disabled"], C = /* @__PURE__ */ m({
  __name: "IstButton",
  props: {
    disabled: { type: Boolean, default: !1 },
    iconName: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    size: { default: "medium" },
    variant: { default: "primary" },
    wcagLabel: { default: void 0 },
    buttonStyle: {},
    rounded: { type: Boolean },
    dense: { type: Boolean },
    elevated: { type: Boolean },
    disable: { type: Boolean },
    round: { type: Boolean },
    flat: { type: Boolean },
    color: {}
  },
  emits: ["click"],
  setup(n, { emit: d }) {
    var e = n;
    const p = d, u = f(), { slotIsEmpty: t } = k({ slot: u.default });
    return e.buttonStyle == "fab" && console.warn("buttonStyle prop is deprecated. Just leave it empty."), e.rounded && console.warn("rounded prop is deprecated. Just remove it."), e.dense && (console.warn("dense prop is deprecated. use small on size prop instead."), e.size = "small"), e.elevated && console.warn("elevated prop is deprecated. Just remove it."), e.disable && console.warn("disable prop is deprecated. use disabled instead."), e.round && console.warn("round prop is deprecated. Just remove it."), e.flat && console.warn("flat prop is deprecated. Just remove it."), e.color && (console.warn("color prop is deprecated. use variant instead."), e.color == "primary" ? e.variant = "primary" : e.color == "neutral" ? e.variant = "secondary" : e.color == "tertiary" ? e.variant = "tertiary" : e.color == "positive" ? e.variant = "positive" : e.color == "negative" && (e.variant = "negative")), (o, i) => (a(), v("button", {
      class: b(["ist-button", [o.size, { fab: r(t) }]]),
      disabled: o.disabled,
      variant: o.variant,
      "aria-label": o.wcagLabel,
      "aria-disabled": o.disabled,
      onClick: i[0] || (i[0] = (c) => p("click", c))
    }, [
      o.iconName && !(o.loading && r(t)) ? (a(), l(w, {
        key: 0,
        class: "ist-button-icon",
        name: o.iconName
      }, null, 8, ["name"])) : s("", !0),
      y(o.$slots, "default", {}, void 0, !0),
      o.loading ? (a(), l(B, {
        key: 1,
        size: "24px"
      })) : s("", !0)
    ], 10, g));
  }
});
export {
  C as default
};
